import App from "./App";
import ReactDOM from "react-dom/client";

const BOOT_DURATION_MS = 3000;
const BOOT_FADE_MS = 260;

const GLOBAL_BOOT_CSS = `
html.ls-boot-lock,
body.ls-boot-lock {
  margin: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
  background: #020705 !important;
  scrollbar-width: none !important;
  overscroll-behavior: none !important;
}
html.ls-boot-lock::-webkit-scrollbar,
body.ls-boot-lock::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}
#root.ls-boot-root-hidden {
  display: none !important;
}
#ls-global-boot {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #020705;
  color: #f4fff8;
  opacity: 1;
  isolation: isolate;
  contain: strict;
  transition: opacity ${BOOT_FADE_MS}ms linear;
}
#ls-global-boot::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(0,245,106,.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,245,106,.035) 1px, transparent 1px);
  background-size: 42px 42px;
}
#ls-global-boot.ls-boot-exit {
  opacity: 0;
  pointer-events: none;
}
.ls-global-boot__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-width: 220px;
  min-height: 150px;
}
.ls-global-boot__svg {
  display: block;
  width: 132px;
  height: 66px;
  overflow: visible;
  transform: translateZ(0);
}
.ls-global-boot__svg path {
  fill: none;
  stroke: #00ff66;
  stroke-width: 5.5;
  stroke-linecap: round;
  stroke-dasharray: 240;
  stroke-dashoffset: 240;
  filter: drop-shadow(0 0 7px rgba(0,255,102,.28));
  will-change: stroke-dashoffset, opacity;
  animation: ls-global-infinity ${BOOT_DURATION_MS}ms linear forwards;
}
.ls-global-boot__label {
  color: #86a994;
  font: 750 12px/1.2 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  letter-spacing: .12em;
  text-transform: uppercase;
  white-space: nowrap;
}
@keyframes ls-global-infinity {
  0%   { stroke-dashoffset: 240; opacity: .72; }
  50%  { stroke-dashoffset: 0; opacity: 1; }
  100% { stroke-dashoffset: -240; opacity: .82; }
}
`;

const createGlobalBoot = () => {
  const html = document.documentElement;
  const body = document.body;
  const root = document.getElementById("root");

  html.classList.add("ls-boot-lock");
  body.classList.add("ls-boot-lock");
  root?.classList.add("ls-boot-root-hidden");

  const style = document.createElement("style");
  style.id = "ls-global-boot-style";
  style.textContent = GLOBAL_BOOT_CSS;
  document.head.appendChild(style);

  const loader = document.createElement("div");
  loader.id = "ls-global-boot";
  loader.setAttribute("role", "status");
  loader.setAttribute("aria-live", "polite");
  loader.setAttribute("aria-label", "Cargando Loopy Studios");
  loader.innerHTML = `
    <div class="ls-global-boot__content">
      <svg class="ls-global-boot__svg" viewBox="0 0 100 50" aria-hidden="true">
        <path d="M 20,25 C 20,10 40,10 50,25 C 60,40 80,40 80,25 C 80,10 60,10 50,25 C 40,40 20,40 20,25 Z"></path>
      </svg>
      <span class="ls-global-boot__label">Cargando Loopy Studios...</span>
    </div>
  `;
  body.appendChild(loader);

  return { loader, style, html, body, root };
};

const mountApp = (rootElement) => {
  if (!rootElement) return;
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
};

const boot = createGlobalBoot();

window.setTimeout(() => {
  boot.loader.classList.add("ls-boot-exit");

  window.setTimeout(() => {
    boot.loader.remove();
    boot.style.remove();
    boot.html.classList.remove("ls-boot-lock");
    boot.body.classList.remove("ls-boot-lock");
    boot.root?.classList.remove("ls-boot-root-hidden");
    mountApp(boot.root);
  }, BOOT_FADE_MS);
}, BOOT_DURATION_MS);
